"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.terms = void 0;

var terms_json_1 = __importDefault(require("./terms.json"));

exports.terms = new Map(Object.entries(terms_json_1.default).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      term = _ref2[0],
      _ref2$ = _ref2[1],
      definition = _ref2$.definition,
      frontmatter = _ref2$.frontmatter;

  return [term, {
    name: term,
    definition: definition,
    frontmatter: frontmatter
  }];
}));